import { render } from "./StorefrontSummary.vue?vue&type=template&id=54ee6afe"
import script from "./StorefrontSummary.vue?vue&type=script&lang=js"
export * from "./StorefrontSummary.vue?vue&type=script&lang=js"

import "./StorefrontSummary.vue?vue&type=style&index=0&id=54ee6afe&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__